import { useCallback, useRef, useState } from 'react';

export function useIsOverflowing(): [React.RefCallback<HTMLElement>, boolean] {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const observerRef = useRef<ResizeObserver | null>(null);

  const ref = useCallback((node: HTMLElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (node) {
      const check = () => setIsOverflowing(node.scrollWidth > node.clientWidth);
      check();
      observerRef.current = new ResizeObserver(check);
      observerRef.current.observe(node);
    }
  }, []);

  return [ref, isOverflowing];
}
